<div
  [ngClass]="{'card-loading': isLoading && !isInEditMode}"
  class="card widget"
  [id]="title+'_'+chartId">
  <div class="card-header py-2">
    <div class="row">
      <div class="col-auto ml-1 mr-0 pr-0">
        <i [ngbTooltip]="getTimeTooltip()" class="fa-solid fa-clock text-muted mr-2" container="body"
        placement="top"></i>
      </div>
      <div class="col ml-0 pl-0 widget-name-truncate"
        [innerHTML]="widgetItem.widgetDetails.widgetName"
        [title]="widgetItem.widgetDetails.widgetName">
      </div>
      @if (!isInEditMode && this.widgetType === UserDefinedWidgetType.COMMAND && !isCommandModeDisabled) {
        <div
          class="col-auto align-items-center justify-content-end">
          <div class="custom-control custom-switch d-inline-flex">
            <input class="custom-control-input" [ngModel]="editCommandEnabled"
              (change)="setCommandMode($event)"
              [id]="widgetItem.widgetDetails.widgetName"
              type="checkbox">
              <label class="custom-control-label" [for]="widgetItem.widgetDetails.widgetName" translate>Write mode</label>
            </div>
          </div>
        }
        @if (displayDetailsButton || isInEditMode) {
          <div class="col-auto align-items-center justify-content-end"
            >
            @if (displayDetailsButton) {
              <button (click)="triggerMoveToInteractiveDataAnalysis()"
                class="btn btn-outline-primary btn-xs" translate>
                Details
              </button>
            }
            @if (isInEditMode) {
              <div class="d-inline-block ml-1" ngbDropdown
                placement="bottom-right">
                <button class="btn btn-outline-primary btn-xs dropdown-no-arrow" id="dropdownManual"
                  ngbDropdownToggle>
                  <span class="fa-solid fa-ellipsis-vertical"></span>
                </button>
                <div aria-labelledby="dropdownManual" ngbDropdownMenu>
                  <button (click)="onEditWidget()" [disabled]="isMap && !machine.isLocationAvailable()" ngbDropdownItem>
                    <i class="fa-solid fa-pen"></i>
                    <span translate>Edit</span>
                  </button>
                  <button (click)="onDeleteWidget()" class="text-danger" ngbDropdownItem>
                    <span class="fa-solid fa-trash"></span>
                    <span translate>Delete</span>
                  </button>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div [ngClass]="{'p-0': isMap}" class="card-body">
      @if (isInEditMode) {
        <div>
          <!-- TODO display something for edit mode?-->
        </div>
      }
      @if (!isLoading && isHighchartsChart) {
        <scitis-highcharts-chart (moveToInteractiveDataAnalysisEvent)="moveToInteractiveDataAnalysis($event)"
          [chartId]="chartId"
          [chartSettings]="widgetItem.userDefinedChartDetails"
          [data]="widgetData"
          [forceHighChartsChartReflow]="forceHighChartsChartReflow"
          [isInEditMode]="isInEditMode"
          [machine]="machine"
          [moveToInteractiveDataAnalysis]="moveToIDA"
          [widgetType]="widgetType"
          [isTemplateWidget]="isTemplateWidget"
          class="chart-widget">
        </scitis-highcharts-chart>
      }

      @if (!isHighchartsChart) {
        <div [ngClass]="{'chart-container-edit-mode':isInEditMode}"
          class="chart-container">
          @if (isImage) {
            <scitis-image-content
              [chartSettings]="widgetItem.userDefinedChartDetails"
              [isInEditMode]="isInEditMode"
              [machine]="machine">
            </scitis-image-content>
          }
          @if (isMap) {
            <scitis-map-content
              [machine]="machine"
              [mapType]="widgetItem.userDefinedChartDetails.mapWidgetMapStyle"
              [zoomLvl]="widgetItem.userDefinedChartDetails.mapWidgetZoomLevel">
            </scitis-map-content>
          }
          @if (isText) {
            <scitis-text-content
              [chartSettings]="widgetItem.userDefinedChartDetails"
              [data]="widgetData"
              [isInEditMode]="isInEditMode"
              [machineSignals]="machine.signals">
            </scitis-text-content>
          }
          @if (this.widgetType === UserDefinedWidgetType.COMMAND) {
            <scitis-command-content
              [chartSettings]="widgetItem.userDefinedChartDetails"
              [data]="widgetData"
              [isInEditMode]="isInEditMode"
              [editCommandEnabled]="editCommandEnabled"
              [machineId]="machine.id ?? -1"
              [userId]="firebaseUserId"
              [machineSignals]="machine.signals">
            </scitis-command-content>
          }
          @if (isStatus) {
            <scitis-status-item [statusEventDetails]="statusEventDetails">
            </scitis-status-item>
          }
        </div>
      }

    </div>
  </div>
